export enum MapRenderError {
  // WebGL is unavailable, so the viewer could not be created.
  UNSUPPORTED = 'unsupported',
  // Rendering stopped: a render loop error or a lost WebGL context.
  RENDER_FAILED = 'render_failed',
}
